import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide } from '@mui/material'
import React from 'react'
import { sxButton } from '../Calendario/style/StyleCalendario';
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalGenerico = ({ mensagem, open, handleClose }) => {


    return (
        <Dialog open={open} slots={{ transition: Transition }} keepMounted onClose={handleClose} aria-describedby="alert-dialog-slide-description"
            sx={{ '& .MuiDialog-paper': { width: 'lg', bgcolor: '#eaeaea', padding: "15px" } }} >
            <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", color: "#141259", position: "relative", paddingRight: 4 }} >
                Atenção!
                <IconButton aria-label="close" onClick={handleClose} sx={{ position: "absolute", right: 1, top: 1, padding: 0 }} >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" sx={{ color: '#000000', textAlign: 'center' }}>
                    {mensagem}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} sx={sxButton} >Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalGenerico
